<template>
  <div class="home">
    <!-- 导航栏 -->
    <NavBar :hide-on-load="true" />

    <!-- 轮播图 -->
    <HeroSection />

    <!-- 公司简介 -->
    <AboutSection />

    <!-- 产品展示 -->
    <ProductsSection />

    <!-- 新闻动态 -->
    <NewsSection />

    <!-- 联系我们 -->
    <ContactSection />

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import HeroSection from '@/components/HeroSection.vue'
import AboutSection from '@/components/AboutSection.vue'
import ProductsSection from '@/components/ProductsSection.vue'
import NewsSection from '@/components/NewsSection.vue'
import ContactSection from '@/components/ContactSection.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    NavBar,
    HeroSection,
    AboutSection,
    ProductsSection,
    NewsSection,
    ContactSection,
    Footer
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      await Promise.all([
        this.$store.dispatch('fetchCompanyInfo'),
        this.$store.dispatch('fetchProducts'),
        this.$store.dispatch('fetchNews')
      ])
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
}
</style>
